import React from "react";
import { format } from "date-fns";
import { Column } from "components/Layout/Grid";
import Text from "components/Text";
import { Button } from "components/Button";
import { currencyOutputNumber } from "utils/CurrencyOutput";

export interface ILostItemDetailSubItem {
  quotationId?: string;
  codeQuotation?: string;
  productCode?: string;
  quotationCreatedAt?: string;
  customerCode?: string;
  buyerName?: string;
  category?: string;
  salePrice?: string | number;
  quotationOrigin?: number;
  status?: string;
  supplierStatus?: string;
}

export interface ILostItemRow {
  quotationId?: string;
  codeQuotation?: string;
  customerCode?: string;
  status?: string;
  supplierStatus?: string;
  quotationOrigin?: number | string;
  productCode?: string;
  productDescription?: string;
  brand?: string;
  subItems?: ILostItemDetailSubItem[];
}

const DETAIL_COLUMNS = [
  { key: "codeQuotation", label: "Cotação" },
  { key: "quotationCreatedAt", label: "Criação" },
  { key: "customerCode", label: "C. Cliente" },
  { key: "buyerName", label: "Razão Social" },
  { key: "category", label: "Categoria" },
  { key: "salePrice", label: "Preço enviado" },
  { key: "quotationOrigin", label: "Origem" },
] as const;

const gridTemplateColumns = "1fr 1fr 1fr minmax(200px, 3.5fr) 1.5fr 1fr 1fr";

function getDetailCellValue(item: ILostItemDetailSubItem, key: string): string {
  if (key === "quotationCreatedAt") {
    return item.quotationCreatedAt
      ? format(new Date(item.quotationCreatedAt), "dd/MM/yyyy' às 'HH:mm")
      : "-";
  }
  if (key === "salePrice") {
    return item.salePrice !== undefined && item.salePrice !== null
      ? currencyOutputNumber(Number(item.salePrice))
      : "-";
  }

  if (key === "quotationOrigin") {
    return item.quotationOrigin === 0 ? "Bionexo" : "MVM";
  }

  const value = item[key as keyof ILostItemDetailSubItem];
  return value !== undefined && value !== null ? String(value) : "-";
}

function subItemToQuotationRow(
  parent: ILostItemRow,
  sub: ILostItemDetailSubItem
): ILostItemRow {
  return {
    ...parent,
    quotationId: sub.quotationId ?? parent.quotationId,
    codeQuotation: sub.codeQuotation ?? parent.codeQuotation,
    customerCode: sub.customerCode ?? parent.customerCode,
    quotationOrigin:
      sub.quotationOrigin !== undefined && sub.quotationOrigin !== null
        ? sub.quotationOrigin
        : parent.quotationOrigin,
    status: sub.status ?? parent.status,
    supplierStatus: sub.supplierStatus ?? parent.supplierStatus,
  };
}

export type LostItemsDetailDropdownProps = ILostItemRow & {
  onOpenQuotation?: (row: ILostItemRow) => void;
};

export const LostItemsDetailDropdown: React.FC<LostItemsDetailDropdownProps> = (props) => {
  const { onOpenQuotation, ...parentRow } = props;
  const subItems = parentRow.subItems ?? [];

  return (
    <Column
      className="animated fadeIn bg-white py-3"
      style={{
        marginLeft: 0,
        width: "100%",
        maxWidth: "100%",
        paddingLeft: 20,
        paddingRight: 20,
      }}
    >
      <Text className="font-bold color-blue-gray mt-2 mb-3" size={12}>
        {subItems.length > 0 ? "" : "Sem itens para exibir"}
      </Text>
      {subItems.length > 0 && (
        <div className="lost-items-detail-grid" style={{ width: "100%" }}>
          <div
            className="lost-items-detail-grid-row lost-items-detail-grid-header"
            style={{ display: "grid", gridTemplateColumns }}
          >
            {DETAIL_COLUMNS.map((col, colIdx) => (
              <div
                key={col.key}
                className="d-flex align-center py-2 px-2 text-left font-bold"
                style={{
                  minWidth: 0,
                  backgroundColor: "#D0DEE1",
                  color: "#2d3748",
                  fontSize: 12,
                  borderTopLeftRadius: colIdx === 0 ? 8 : 0,
                  borderTopRightRadius:
                    colIdx === DETAIL_COLUMNS.length - 1 ? 8 : 0,
                }}
              >
                {col.label}
              </div>
            ))}
          </div>
          {subItems.map((item, idx) => (
            <div
              key={idx}
              className="lost-items-detail-grid-row"
              style={{
                display: "grid",
                gridTemplateColumns,
                minHeight: 50,
                alignItems: "center",
                backgroundColor: idx % 2 === 0 ? "#ffffff" : "#F5F7F8",
              }}
            >
              {DETAIL_COLUMNS.map((col) => (
                <div
                  key={col.key}
                  className="color-blue-gray text-left py-2 px-2"
                  style={{ minWidth: 0, fontSize: 12 }}
                >
                  {onOpenQuotation && (
                    <Button
                      width="100%"
                      className="text-left color-primary w-100 p-0 justify-start"
                      style={{ minWidth: 0, fontSize: 12 }}
                      onClick={() =>
                        onOpenQuotation(subItemToQuotationRow(parentRow, item))
                      }
                    >
                      <span className="color-primary">
                        {getDetailCellValue(item, col.key)}
                      </span>
                    </Button>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </Column>
  );
};
